module.exports = __webpack_public_path__ + "img/hontai_DarkBlue.7b77313f.png";